import { Injectable } from '@angular/core';

import { setoresRoute } from "./data.service";
import { estruturasRoute } from "../../shared/data.service";
import { AuthService } from "../../../shared/services/auth.service";
import { editRoute, newRoute } from "../../../shared/services/data.service";
import { divisoesRoute } from "../../divisoes/shared/data.service";

@Injectable()
export class SetorNavigationService {
  moduleRouter: string = setoresRoute;
  divisoesRouter: string = divisoesRoute;
  fatherRouter: string = estruturasRoute;

  constructor(
    private _authService: AuthService
  ) { }

  goToList() {
    var router: string = this.fatherRouter + '/' + this.divisoesRouter;
    this._authService.navigateTo(router);
  }

  goToNew() {
    var router: string = this.fatherRouter + '/' + this.moduleRouter + '/' + newRoute;
    this._authService.navigateTo(router);
  }

  goToEdit(objectId: number) {
    var router: string = this.fatherRouter + '/' + this.moduleRouter + '/' + editRoute;
    this._authService.navigateTo(router, objectId);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/setores/shared/setor-navigation.service.ts
 **/